import {
  UnsupportedBrowser as UnsupportedBrowserEncore,
  Type,
  TextLink,
} from '@spotify-internal/encore-web';
import React from 'react';
import { useT } from '@spotify-internal/i18n-core';

export const UnsupportedBrowser = () => {
  const translate = useT();

  return (
    <UnsupportedBrowserEncore>
      <Type as="p" variant="altoBrio" data-testid="unsupported-browser">
        {translate(
          'S4MP_UNSUPPORTED_BROWSER',
          'Your browser doesn’t work with this application',
          'Message to tell the user that their browser is not compatible with s4mp.',
        )}
      </Type>
      <Type as="p" variant="altoBrio">
        <TextLink
          href="https://browser-update.org/update-browser.html"
          standalone
        >
          {translate(
            'S4MP_UPDATE_BROWSER',
            'Switch or update your browser',
            'Link to a page to switch or update to a modern browser',
          )}
        </TextLink>
      </Type>
    </UnsupportedBrowserEncore>
  );
};
